
<!-- Standing Order -->
<div class="flex flex-col overflow-y-auto h-full">
    <div>
        <app-create-trip #createTripComponent (dataLoaded)="onTripDataLoaded()" [isFromStandingOrder]="true" [standingOrderId]="standingOrderId" ></app-create-trip>
    </div>
    <div class="w-full p-4 rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10 shadow-lg flex-1">
        <h3 class="text-lg font-medium leading-6 text-xs-dark">
            Standingorder
        </h3>
        <div class="mt-4 border-2 border-dashed border-zinc-950/10 dark:border-white/10 rounded-lg p-2 flex flex-col gap-4">
            <form [formGroup]="standingOrderForm" (ngSubmit)="createStandingOrder()">
                <div class="grid grid-cols-1 gap-2 sm:grid-cols-6">
                    <div class="sm:col-span-2">
                        <label for="appointmentType" class="block text-sm font-medium text-main-secondary">
                            Status
                        </label>
                        <div class="mt-1">
                            <select id="isActive" formControlName="isActive" (change)="onSelectStatus($event)">
                                <option [value]="true">Active</option>
                                <option *ngIf="standingOrderId" [value]="false">Inactive</option>
                            </select>
                        </div>
                        <div *ngIf="form.isActive.errors && submitted">
                            <div *ngIf="form.isActive.errors.required" class="error">
                                <p class="mt-2 text-xs text-main-danger font-bold">
                                    Appointment Status is required
                                </p>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="isStandingOrder === true">
                        <div class="sm:col-span-2">
                            <label for="startDate" class="block text-sm font-medium text-main-secondary">
                                Start Date
                            </label>
                            <div class="mt-1 relative">
                                <input type="text" name="startDate" id="startDate" formControlName="startDate"
                                    [owlDateTime]="dtStartTime" [owlDateTimeTrigger]="dtStartTime" [readOnly]="true" />
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <span class="text-gray-500 sm:text-sm" id="price-currency">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-main-light"
                                            viewBox="0 0 24 24">
                                            <g fill="none" stroke="currentColor" stroke-linecap="round"
                                                stroke-linejoin="round" stroke-width="2">
                                                <path d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                <path d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                <path d="M18 16.496V18l1 1" />
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                                <div *ngIf="form.startDate.errors && submitted">
                                    <div *ngIf="form.startDate.errors.required" class="error">
                                        <p class="mt-2 text-red-600 text-xs">
                                            Start Date is required
                                        </p>
                                    </div>
                                    <div *ngIf="form.startDate.errors.owlDateTimeMin" class="error">
                                        <p class="mt-2 text-red-600 text-xs">
                                            Start Date is required
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(form.startDate)"
                                #dtStartTime></owl-date-time>
                        </div>
                        <div class="sm:col-span-2">
                            <label for="endDate" class="block text-sm font-medium text-main-secondary">
                                End Date
                            </label>
                            <div class="mt-1 relative">
                                <input type="text" name="endDate" id="endDate" formControlName="endDate"
                                    [owlDateTime]="dtEndTime" [owlDateTimeTrigger]="dtEndTime"
                                    [min]="form.startDate.value"  [readOnly]="true" />
                                <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                                    <span class="text-gray-500 sm:text-sm" id="price-currency">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-main-light"
                                            viewBox="0 0 24 24">
                                            <g fill="none" stroke="currentColor" stroke-linecap="round"
                                                stroke-linejoin="round" stroke-width="2">
                                                <path d="M11.795 21H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                                                <path d="M14 18a4 4 0 1 0 8 0a4 4 0 1 0-8 0m1-15v4M7 3v4m-4 4h16" />
                                                <path d="M18 16.496V18l1 1" />
                                            </g>
                                        </svg>
                                    </span>
                                </div>
                                <div *ngIf="form.endDate.errors && submitted">
                                    <div *ngIf="form.endDate.errors.required" class="error">
                                        <p class="mt-2 text-red-600 text-xs">
                                            End Date is required
                                        </p>
                                    </div>                   
                                    
                                </div>
                            </div>
                            <div *ngIf="form.endDate.errors?.owlDateTimeMin" class="error">
                                <p class="mt-2 text-red-600 text-xs">End date must be later than the start date</p>
                            </div>
                            <owl-date-time [pickerType]="'calendar'" (afterPickerClosed)="onDateChange(form.endDate)"
                                #dtEndTime></owl-date-time>
                        </div>
                    </ng-container>
                </div>
                <div class="pt-4" *ngIf="isStandingOrder === true">
                        <label for="days" class="block text-sm font-medium text-main-secondary">
                            Days <span class="text-red-600">*</span>
                        </label>
                    <div class="mt-1 flex space-x-2 border-2 border-dashed border-zinc-950/10 dark:border-white/10 p-2 rounded-lg bg-zinc-950/5 dark:bg-white/5 gap-y-2">
                       
                        <div class="" *ngFor="let day of days; let i = index;">
                            <ng-container>
                              <div class="sm:col-span-2">
                                <div class="flex items-center justify-center gap-2">
                                  <input 
                                    type="checkbox" 
                                    [id]="'daycheckbox-' + i" 
                                    [checked]="day.checked"
                                    (change)="onDaySelection(day)"
                                  >
                                  <label [for]="'daycheckbox-' + i">
                                    {{ day.label | titlecase }}
                                  </label>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                       
                    </div>
                     <div *ngIf="standingOrderForm.get('repeat')?.errors && submitted">
                            <div *ngIf="standingOrderForm.get('repeat')?.hasError('required')" class="error">
                                <p class="mt-1 text-red-600 text-xs">
                                Days are required
                                </p>
                            </div>
                        </div>
                </div>
                <div class="pt-4">
                    <div class="flex justify-end gap-2">
                        <button type="submit" class="ml-3 btn btn-secondary">{{standingOrderId ? "Update":"Create"}}</button>
                        <!-- <button type="button" (click)="dummyData()" class="ml-3 btn btn-primary">Dummy Data</button> -->
                    </div>
                </div>
            </form>
    
        </div>
    </div>
    
</div>
